export default __webpack_public_path__ + "static/media/4.eb134b71.jpg";